import { React, PT, fetchApi } from '@gasbuddy/react';
import { Header, Button, Modal, Icon, Form, Dropdown, Input } from 'semantic-ui-react';

const defaultState = {
  loading: false,
  opened: false,
};

const reasonOptions = [
  { value: 'dynamic', text: 'Forgot to claim dynamic discount' },
  { value: 'goodwill', text: 'Goodwill for bad customer experience' },
  { value: 'incorrect-discount', text: 'Incorrect or missing discount' },
  { value: 'getupside', text: 'Missed GetUpside reward' },
  { value: 'membership', text: 'Membership Fee Credit' },
  { value: 'missing-gasback', text: 'Missing GasBack' },
  { value: 'research', text: 'Research Incentives' },
  { value: 'check', text: 'Check (Cheque in Canuck) Received' },
  { value: 'loyalty-connect', text: 'Loyalty Connect' },
  { value: 'daily-draw', text: 'Daily Draw' },
  { value: 'payments-partner-reconciliation', text: 'Payments Partner Reconciliation' },
  { value: 'other', text: 'Other reason, not listed' },
];

export class CreditModal extends React.Component {
  state = defaultState

  onChange = (field, value) => {
    this.setState({ [field]: value });
  }

  issueCredit = () => {
    const { accountId, onCredit } = this.props;
    const { amount, memo, reason } = this.state;
    this.setState({ loading: true }, async () => {
      try {
        const { status, body } = await fetchApi({
          url: `/payments/transactions/create-credit/${accountId}`,
          body: {
            amount,
            memo,
            reason,
          },
        });
        if (status !== 200) {
          this.setState({ error: { message: body.error } });
        } else {
          this.setState(defaultState, () => {
            if (onCredit) {
              onCredit();
            }
          });
        }
      } catch (error) {
        this.setState({ error });
      }
    });
  }

  render() {
    const { error, opened, loading, memo, amount, reason } = this.state;
    const { accountId } = this.props;

    if (!accountId) {
      return null;
    }

    if (error) {
      return (
        <Modal open>
          <Header icon="attention" content="An Error Has Occurred" />
          <Modal.Content>
            <p>{error.message}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button basic color="grey" onClick={() => this.setState({ error: null, loading: false })}>
              <Icon name="minus" />
              {' '}
Ok
            </Button>
          </Modal.Actions>
        </Modal>
      );
    }

    if (!opened) {
      return <Button onClick={() => this.setState({ opened: true })}>Add Credit</Button>;
    }

    return (
      <Modal open>
        <Header icon="dollar" content="Add an account credit" />
        <Modal.Content>
          <Form loading={loading}>
            <Form.Field>
              <Dropdown
                placeholder="Select a reason for the credit"
                value={reason}
                options={reasonOptions}
                onChange={(e, el) => this.setState({ reason: el.value })}
                search
                selection
              />
            </Form.Field>
            <Form.Field>
              <Input
                name="memo"
                value={memo}
                onChange={(e, { value }) => this.onChange('memo', value)}
                placeholder="Memo (explain why the credit was issued)"
              />
            </Form.Field>
            <Form.Field>
              <Input
                fluid
                size="large"
                label="$"
                labelPosition="left"
                placeholder="0.00"
                value={amount}
                ref={(v) => { this.amountField = v; }}
                id="amount"
                onChange={(e, { value }) => this.onChange('amount', value)}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
Cancel
          </Button>
          <Button basic color="red" onClick={this.issueCredit}>
            <Icon name="money" />
            {' '}
Issue Credit
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

CreditModal.propTypes = {
  accountId: PT.number,
  onCredit: PT.func,
};

CreditModal.defaultProps = {
  accountId: 0,
  onCredit: null,
};
